var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { FaLock } from 'react-icons/fa';
import cometList from '../../../../Fct/plugins/compoundv3/helpers/cometList.json';
import depositAssets from '../helpers/depositAssets.json';
export var CollateralBalanceOf = createPlugin({
    protocol: 'COMPOUND_V3',
    type: 'GETTER',
    method: 'collateralBalanceOf',
    description: 'Function returns the current balance of a collateral asset for a specified account in the protocol.',
    supportedContracts: cometList,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    account: new FctAddress({ isPreview: true, icon: FaLock }),
                    asset: new FctAddress({
                        destination: 'erc20',
                        options: depositAssets
                            .filter(function (token) { return token.chainId === Number(chainId); })
                            .map(function (asset) { return (__assign(__assign({}, asset), { value: asset.address })); }),
                        isPreview: true,
                        icon: FaLock
                    }),
                },
            },
            output: { balance: new FctValue({ innerIndex: 0, isPreview: true }) },
        });
    },
});
